import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '../ui/pagination'

export const KycPagination = ({
  currentPage = 0,
  totalPages = 1,
  onPageChange = () => {}, // default no-op
}) => {
  const pagesToShow = 5 // Number of page links to display around the current page

  const getPageNumbers = () => {
    const pages = []
    const startPage = Math.max(0, currentPage - Math.floor(pagesToShow / 2))
    const endPage = Math.min(totalPages - 1, currentPage + Math.floor(pagesToShow / 2))

    if (startPage > 0) {
      pages.push(0)
      if (startPage > 1) {
        pages.push('ellipsis')
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i)
    }

    if (endPage < totalPages - 1) {
      if (endPage < totalPages - 2) {
        pages.push('ellipsis')
      }
      pages.push(totalPages - 1)
    }

    return pages
  }

  const pageNumbers = getPageNumbers()

  return (
    <Pagination>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            href='#'
            onClick={() => onPageChange(Math.max(0, currentPage - 1))}
            className={currentPage === 0 ? 'pointer-events-none opacity-50' : ''}
          />
        </PaginationItem>

        {pageNumbers.map((page, index) => (
          <PaginationItem key={index}>
            {page === 'ellipsis' ? (
              <PaginationEllipsis />
            ) : (
              <PaginationLink
                href='#'
                isActive={page === currentPage}
                onClick={() => onPageChange(page)}
              >
                {page + 1}
              </PaginationLink>
            )}
          </PaginationItem>
        ))}

        <PaginationItem>
          <PaginationNext
            href='#'
            onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
            className={currentPage === totalPages - 1 ? 'pointer-events-none opacity-50' : ''}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}

export default KycPagination
